import {
  GET_PLAYER_PROFILES,
  GET_PLAYER_PROFILES_SUCCESS,
  GET_PLAYER_PROFILES_FAIL,
  GET_PLAYER_PROFILE_DETAILS,
  GET_PLAYER_PROFILE_DETAILS_SUCCESS,
  GET_PLAYER_PROFILE_DETAILS_FAIL,
  GET_PLAYER_PROFILE_ENTRIES,
  GET_PLAYER_PROFILE_ENTRIES_SUCCESS,
  GET_PLAYER_PROFILE_ENTRIES_FAIL,
  GET_DISTINCT_PLAYERS,
  GET_DISTINCT_PLAYERS_SUCCESS,
  GET_DISTINCT_PLAYERS_FAIL,
  SET_SEARCH_TERM,
  SET_DATE_RANGE,
  CLEAR_DATE_FILTER,
  SET_SORT_KEY,
  SET_SORT_DIRECTION,
  SET_CURRENT_PAGE,
  SET_ITEMS_PER_PAGE,
  SET_MODAL_STATE,
  SET_LOADING_STATE,
  SEARCH_PLAYERS_WITH_SUGGESTIONS,
  SEARCH_PLAYERS_WITH_SUGGESTIONS_SUCCESS,
  SEARCH_PLAYERS_WITH_SUGGESTIONS_FAIL,
  GET_PLAYER_PROFILE_STATS,
  GET_PLAYER_PROFILE_STATS_SUCCESS,
  GET_PLAYER_PROFILE_STATS_FAIL,
  SET_ALL_PLAYERS,
  SET_PLAYER_PROFILE_STATS,
  SET_LOADING,
  SET_STATS_LOADING,
  SET_ERROR,
} from "../actions/playerprofile";

const initialState = {
  playerProfiles: [],
  currentPlayerProfile: null,
  isLoading: false,
  error: null,
  distinctPlayers: [],
  totalPlayers: 0,
  searchTerm: '',
  startDate: null,
  endDate: null,
  sortKey: 'createdAt',
  sortDirection: 'desc',
  currentPage: 1,
  itemsPerPage: 10,
  modalOpen: false,
  playerProfileEntries: [],
  playerProfileStats: null,
  searchSuggestions: [],
};

export default function playerprofileReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PLAYER_PROFILES:
    case GET_PLAYER_PROFILE_DETAILS:
    case GET_PLAYER_PROFILE_ENTRIES:
    case GET_DISTINCT_PLAYERS:
    case SEARCH_PLAYERS_WITH_SUGGESTIONS:
    case GET_PLAYER_PROFILE_STATS:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case GET_PLAYER_PROFILES_SUCCESS:

      return {
        ...state,
        isLoading: false,
        playerProfiles: action.payload,
        error: null,
      };

    case GET_DISTINCT_PLAYERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        distinctPlayers: action.payload?.data || [],
        totalPlayers: action.payload?.pagination?.totalItems || 0,
        error: null,
      };

    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };

    case GET_PLAYER_PROFILE_STATS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        playerProfileStats: action.payload,
        error: null,
      };

    case GET_PLAYER_PROFILE_ENTRIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        playerProfileEntries: action.payload,
        error: null,
      };

    case GET_PLAYER_PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        currentPlayerProfile: action.payload,
        error: null,
      };

    case SEARCH_PLAYERS_WITH_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        searchSuggestions: action.payload,
        error: null,
      };

    case SET_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.payload,
        currentPage: 1, // Reset to first page on new search
      };

    case SET_DATE_RANGE:
      return {
        ...state,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
        currentPage: 1, // Reset to first page on date filter change
      };

    case CLEAR_DATE_FILTER:
      return {
        ...state,
        startDate: null,
        endDate: null,
        currentPage: 1, // Reset to first page when clearing filter
      };

    case SET_SORT_KEY:
      return {
        ...state,
        sortKey: action.payload,
      };

    case SET_SORT_DIRECTION:
      return {
        ...state,
        sortDirection: action.payload,
      };

    case SET_ITEMS_PER_PAGE:
      return {
        ...state,
        itemsPerPage: action.payload,
        currentPage: 1, // Reset to first page when changing items per page
      };

    case SET_MODAL_STATE:
      return {
        ...state,
        modalOpen: action.payload,
      };

    case SET_LOADING_STATE:
      return {
        ...state,
        isLoading: action.payload,
      };


    case SET_ALL_PLAYERS:
      return { ...state, allPlayers: action.payload, loading: false };

    case SET_PLAYER_PROFILE_STATS:
      return { ...state, stats: action.payload, statsLoading: false };

    case SET_LOADING:
      return { ...state, loading: action.payload };

    case SET_STATS_LOADING:
      return { ...state, statsLoading: action.payload };

    case SET_ERROR:
      return { ...state, error: action.payload, loading: false };


    case GET_PLAYER_PROFILES_FAIL:
    case GET_PLAYER_PROFILE_DETAILS_FAIL:
    case GET_PLAYER_PROFILE_ENTRIES_FAIL:
    case GET_DISTINCT_PLAYERS_FAIL:
    case SEARCH_PLAYERS_WITH_SUGGESTIONS_FAIL:
    case GET_PLAYER_PROFILE_STATS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
